SupportProgressBarView = require('./progress_bar_view')
SharedWidgetLayoutView = require('../../../shared/frontend/views/widget_layout_veiw')
SupportUtilsHelper = require('../helpers/utils')
Backbone = require 'backbone'
Backbone.$ = $
SupportProblemSolvedTemplate = require('../../problem_solved.html.mustache')

class SupportProblemSolvedView extends Backbone.View
  className: 'problem-solved'

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.support'
    @template = SupportProblemSolvedTemplate
    @id = 'problem-solved'

  events:
    'click .contact-us-from-problem-solved' : 'renderStepThree'
    'click #needHelpAgain': 'renderStepTwo'

  render: ->
    @$el.append toHtml(@template, @toHash(@options), @I18nScope)
    @hideComponents()
    @showComponents()

  renderStepThree: ->
    propagateEventBeforeReplacingElements( -> Backbone.history.navigate('#contact-us', {trigger: true}))

  renderStepTwo: ->
    $('.step-container', '#v2_other').empty()
    $('.vertical-container').show()
    SharedWidgetLayoutView.hideWidgets()
    propagateEventBeforeReplacingElements( -> Backbone.history.navigate('#select-issue', {trigger: false}))

  toHash: (options = {})->
    options

  hideComponents: ->
    SupportUtilsHelper.hideFloatingBoldChat()

  showComponents: ->
    SharedWidgetLayoutView.showWidgets('problem-solved')

  close: ->

module.exports = SupportProblemSolvedView
